export function getNewInputValue(value: string, inputValue: string) {
  const inputArr = inputValue.split(' ');

  if (inputArr.length > 2) {
    return `${inputArr[0]} ${inputArr[1]} ${value}`;
  }

  if (inputArr.length > 1) {
    return `${inputArr[0]} ${value} `;
  }

  return `${value} `;
}
